import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import {
  APP_FILE_CSIO_EDOCS,
  APP_FILE_CSIO_EDOCS_LIST,
  APP_FILE_MANAGE_CSIO_EDOCS,
} from "./csioEdocs.constants";

const CSIOEDOCSList = Loadable(
  lazy(() =>
    import("./CSIODocsList").then(({ CSIOEDocsList }) => ({
      default: CSIOEDocsList,
    }))
  )
);
const ManageCSIODocs = Loadable(
  lazy(() =>
    import("./ManageCSIOEdocsWrapper").then(({ ManageCSIOEdocsWrapper }) => ({
      default: ManageCSIOEdocsWrapper,
    }))
  )
);
const CSIOEdocs = Loadable(
  lazy(() =>
    import("./ManageCSIOEdocsWrapper").then(({ ManageCSIOEdocsWrapper }) => ({
      default: ManageCSIOEdocsWrapper,
    }))
  )
);

const CSIOInvoicingList = Loadable(
  lazy(() =>
    import("../Accounting/InvoiceInformation/CSIOInvoicingList").then(
      ({ CSIOInvoicingList }) => ({
        default: CSIOInvoicingList,
      })
    )
  )
);

const MpoiListWrapper = Loadable(
  lazy(() =>
    import("./MPOI/MPOILIstWrapper").then(({ MpoiListWrapper }) => ({
      default: MpoiListWrapper,
    }))
  )
);

export const csioEdocsRoutes = [
  {
    path: `${APP_FILE_CSIO_EDOCS_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.CSIO_EDOCS]}>
        <CSIOEDOCSList />
      </AuthorizedRoute>
    ),
  },

  {
    path: `${APP_FILE_MANAGE_CSIO_EDOCS}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.CSIO_EDOCS]}>
        <ManageCSIODocs />
      </AuthorizedRoute>
    ),
  },

  {
    path: `${APP_FILE_MANAGE_CSIO_EDOCS}/:type/:csioEdocsId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.CSIO_EDOCS]}>
        <ManageCSIODocs />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_CSIO_EDOCS}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.CSIO_EDOCS]}>
        <CSIOEdocs />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_CSIO_EDOCS}/:messageGUID`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.CSIO_EDOCS]}>
        <CSIOEdocs />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/csio-invoicing`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.CSIO_EDOCS]}>
        <CSIOInvoicingList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/csio-mpoi-list`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.CSIO_EDOCS]}>
        <MpoiListWrapper />
      </AuthorizedRoute>
    ),
  },
];
